import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';
const TABLE_COLUMNS = [
  {
    header: 'BloodType',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black',
          }}
        >
          {`${row.blood_type}`}
        </span>
      );
    },
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialBloodTypeDataObj = {
  data: [],
  loading: false
};

export const BloodTypeMaster  = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [bloodTypeDataObj, setBloodTypeDataObj] = useState(initialBloodTypeDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();


  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({ blood_type: Yup.string().required('Blood Type is required') })),
    defaultValues: { blood_type: '', default: false },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('blood_type', selectedRecord.blood_type);
      setValue('default', selectedRecord.status === 'default');
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/blood-type-update' : '/blood-type-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        blood_type: formValues.blood_type,
        status: formValues.default ? 'default' : 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Blood Type master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Blood Type master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/blood-type-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Blood Type master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Blood Type master', { variant: 'error' });
    }
    setLoading(false);
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/blood-type-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Blood Type master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Blood Type master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setBloodTypeDataObj({ loading: true });
    const response = await request('/blood-type-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(item =>
        item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setBloodTypeDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setBloodTypeDataObj({ loading: false });
    }
  };

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',

          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              Blood Type Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                  id={`${lastPathSegment}Write`}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord()
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={2} sx={{ marginBottom: "1%" }}>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700 }}>Blood Type Name</Typography>
                <TextField
                  name="blood_type"
                  sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                  inputProps={{ sx: { fontSize: '1.4rem' } }}
                  placeholder="Enter BloodType Name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Default</Typography>
                  <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="default" fontSize={18} />
                </Stack>
              </Stack>
</Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            BloodType Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={bloodTypeDataObj.data || []}
          loading={bloodTypeDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
